function getProductJSON(handle) {
  var url = '/products/' + handle + '.js';
  return $.getJSON(url);
}

function getAllProducts(options) {
  return new Promise(function (resolve, reject) {
    var product_promises = [];
    options.split('|').forEach(function (handle) {
      product_promises.push(getProductJSON(handle));
    });

    Promise.all(product_promises).then(function (products) {
      resolve(products);
    });
  });
}

function getAllProductsCollection(collection) {
  return new Promise(function (resolve, reject) {
    var collection_url = '/collections/' + collection + '/products.json?limit=500';
    $.getJSON(collection_url).then(function (data) {
      var products = data.products;
      products.forEach(function (product) {
        var available_variants = product.variants.filter(function (variant) {
          return variant.available;
        });

        product.available = available_variants.length > 0;
        product.selected = false;
        product.quantity = 0;
      });
      resolve(products);
    })
  });
}

function getAllAddonsCollection(collection) {
  return new Promise(function (resolve, reject) {
    var currencyFormat = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
    var collection_url = '/collections/' + collection + '/products.json?limit=500';
    $.getJSON(collection_url).then(function (data) {
      var addons = data.products;
      addons.forEach(function (addon) {
        var available_variants = addon.variants.filter(function (variant) {
          return variant.available;
        });
        addon.available = available_variants.length > 0;
        addon.selected = false;
        addon.quantity = 0;
        // addon.price = Currency.formatMoney(addon.variants[0].price, window.theme.moneyFormat);
        addon.price = currencyFormat.replace("{{amount}}", addon.variants[0].price);
      });
      resolve(addons);
    })
  });
}

function observeMutations(elementSelector, callback) {
  if (document.querySelectorAll(elementSelector).length == 0) {
    return;
  }
  var observer = new MutationObserver(callback);
  var config = { attributes: true, childList: true, characterData: false };
  observer.observe(document.querySelector(elementSelector), config);

  return observer;
}

function addItemsToCart(itemsToAdd) {
  return new Promise((resolve, reject) => {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: itemsToAdd })
    })
      .then(resolve)
      .catch(reject);
  });
}
function addItemToCart(itemsToAdd) {
  return new Promise((resolve, reject) => {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify( itemsToAdd )
    })
      .then(resolve)
      .catch(reject);
  });
}

var SELECTORS = {
  quantity: '[data-pf-type="ProductQuantity"]',
  bundle_set_container: '.bundle-sets-container',
  variant_ids_property: '#set-variant-ids',
  btn_atc: '[data-pf-type="ProductATC"]'
};

var LABELS = {
  option_title: 'Color'
}

// Vue filters
Vue.filter('resize_img', function (src, size) {
  var resized = src || '';
  resized = resized.replace('.png', `_${size}.png`);
  resized = resized.replace('.jpg', `_${size}.jpg`);

  return resized;
});

// Vue components
var productCard = Vue.component('product-card', {
  template: '#product-card',
  props: ['product', 'is_bundle_complete'],
  delimiters: ['${', '}'],
  data: function () {
    return {
      _product: this.product,
      qty: this.product.quantity
    }
  },
  watch: {
    qty: function () {
      this.product.quantity = this.qty;
    },
    'product.quantity': function () {
      this.qty = this.product.quantity;
      this.product.selected = this.qty > 0;
    },
    'product.selected': function () {
      this.qty = this.product.selected ? 1 : 0;
      setTimeout(() => {
        $(SELECTORS.bundle_set_container).find('select').each((index, select) => {
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }, 0);
    }
  },
  methods: {
    togglePolishSelection: function (e, product) {
      if (this.is_bundle_complete && !product.selected) {
        return;
      }

      this.product.selected = !this.product.selected;
    }
  }
});

var bundle_vm = new Vue({
  el: SELECTORS.bundle_set_container,

  data: {
    labels: LABELS,
    selectors: SELECTORS,
    bundle_config: bundle_config,
    products: [],
    addons: [],
  },

  computed: {
    main_variant: function () {
      return this.bundle_config.product.variants[0];
    },
    sets: function () {
      return new Array(this.bundle_config.options_count).fill('x').map(function (item, index) {
        return {
          index: (index + 1)
        }
      });
    },

    selected_items: function () {
      var selected = [];

      this.products.forEach(function (product) {
        if (product.quantity > 0) {
          for (var i = 0; i < product.quantity; i++) {
            selected.push(product);
          }
        }
      });

      return selected;
    },

    is_bundle_complete: function () {
      return this.selected_items.length == this.bundle_config.options_count;
    },

    remaining: function () {
      return this.bundle_config.options_count - this.selected_items.length;
    },

    available_products: function () {
      return this.products.filter(function (product) {
        return product.available;
      });
    },

    available_addons: function () {
      return this.addons.filter(function (addon) {
        return addon.available;
      });
    }
  },

  beforeCreate: function () {
    if (!bundle_config.enabled) {
      return;
    }

    var _this = this;
    var getProducts = bundle_config.options_collection ? getAllProductsCollection(bundle_config.options_collection) : getAllProducts(bundle_config.options);
    getProducts.then(function (products) {
      _this.$set(_this, 'products', products);
      setTimeout(_this.setHiddenVariantsProperty, 0); // calculate in next cycle
    });

    var getAddons = getAllAddonsCollection(bundle_config.addons_collection);
    getAddons.then(function (addons) {
      _this.$set(_this, 'addons', addons);
      setTimeout(_this.setHiddenVariantsProperty, 0); // calculate in next cycle
    });

  },

  mounted: function () {
    this.keepAlive();

    if (this.bundle_config.enabled) {
      this.renderContainer();
    }
  },

  components: {
    productCard: productCard
  },

  watch: {
    selected_items: function () {
      this.updateAtcBtn();
    }
  },

  methods: {
    keepAlive: function () {
      // disabled 2026-10-10: bundles-app.herokuapp.com is gone (Heroku 404, CORS-blocked); this was only a wake-up ping
    },

    renderContainer: function () {
      var _this = this;

      // Move container to location
      $(SELECTORS.quantity).before($(SELECTORS.bundle_set_container));

      setTimeout(_this.updateAtcBtn, 1000);
      setTimeout(_this.updateAtcBtn, 1500);
    },

    getColorsProperty: function () {
      var colorsProp = {};
      $(SELECTORS.bundle_set_container).find('select option:selected').each((index, option) => {
        colorsProp[`Color ${(index + 1)}`] = option.value;
      });
      return colorsProp;
    },

    getHiddenVariantsProperty: function () {
      var selected_variant_ids = $(SELECTORS.bundle_set_container).find('select option:selected').map(function (optionIndex, option) {
        return $(option).data('variant-id');
      }).toArray();

      return selected_variant_ids;
    },

    setHiddenVariantsProperty: function () {
      var selected_variant_ids = this.getHiddenVariantsProperty();
      $(SELECTORS.variant_ids_property).val(selected_variant_ids.join('|'));
    },

    // Event handlers
    optionChanged: function (e) {
      //console.log(e);
      this.setHiddenVariantsProperty();
      this.updateAtcBtn();
    },

    updateAtcBtn: function () {
      var _this = this;

      if (!_this.bundle_config.product.available) {
        return;
      }

      var $atc_btn = $(SELECTORS.btn_atc);
      var selected_variant_ids = $(SELECTORS.bundle_set_container).find('select option:selected').map(function (optionIndex, option) {
        return $(option).data('variant-id');
      }).toArray();

      //var all_selected = selected_variant_ids.length == _this.bundle_config.options_count;
      var is_bundle_complete = _this.is_bundle_complete;

      $atc_btn.prop('disabled', !is_bundle_complete);
      $atc_btn.find('span').text(is_bundle_complete ? 'Add to Cart' : 'Choose Colors');
      $atc_btn.toggleClass('active', is_bundle_complete);
    },

    openColorSelectionModal: function (e) {
      e.preventDefault();
      Fancybox.show([
        {
          src: '#bundle-sets-ui'
        }
      ], {
        dragToClose: false
      });
    },

    addToCart: function (e) {
      $('#bundle-sets-ui .modal-title').addClass('loading');
      var _this = this;
      var $button = $(e.currentTarget);
      e.preventDefault();
      _this.updateAtcBtn();

      var props = {};
      props = Object.assign(props, _this.getColorsProperty());
      props = Object.assign(props, {
        '_bundle-set': true,
        '_bundle_variant_reference_ids': _this.getHiddenVariantsProperty().join('|')
      });

      var itemsToAdd = [
        {
          id: _this.main_variant.id,
          quantity: 1,
          properties: props
        }
      ];
      //console.log(itemsToAdd);

      addItemsToCart(itemsToAdd)
        .then((res) => {          
          $button.after('<div class="add-success">Added to Cart!</div>')
          setTimeout(() => {
            $('.add-success').remove();
            //$('<br><button class="bundle-add-to-cart">Go to Cart</button>').insertAfter('.bundle-add-to-cart');
            //$('.bundle-sets-header').append('<button class="bundle-add-to-cart" onclick="addonsToCart($event)">Go to Cart</button>');
            $('#bundle-sets-ui').addClass('show-popup');
            _this.clearBundle();
            //Fancybox.close();
            $('#bundle-sets-ui .modal-title').removeClass('loading');
          }, 1500);
        })
        .then(console.error);
    },

    addonsToCart: function (e) {
      var _this = this;
      var itemsToAdd = [];
      $('body').find('.gotocart-popup .product-card.selected').each((i, e) => {
        var data = {
                'form-type' : 'product',
                'id'        : $(e).find('.product-card-wrap').data('id'),
                'quantity'  : parseInt($(e).find('.item-qty span:nth-of-type(2)').text())
              };
        itemsToAdd.push(data);
      });
      addItemsToCart(itemsToAdd)
        .then((res) => {
          //alert("Success");
          setTimeout(function(){ location.href="/cart"; }, 300);
        })
        .then(console.error);
    },

    addToCartOld: function (e) {
      var _this = this;

      e.preventDefault();
      //Fancybox.close();
      _this.updateAtcBtn();
      setTimeout(function () {
        $(SELECTORS.btn_atc).click();
        _this.clearBundle();
      }, 150);
    },

    clearBundle: function () {
      var _this = this;
      _this.products.forEach(function (product) {
        product.selected = false;
      });

      setTimeout(this.updateAtcBtn, 0);
      //setTimeout(function(){ location.href="/cart"; }, 300);
    }
  }
});
